let view = null;

export default {
	namespace: 'template-step',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: StepView } = await import(/* webpackChunkName: "step-view" */ '../../templates/StepView');
		view = new StepView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
